import { SiteFloorUpdate } from '~/modules/sites';
import dashboardWrapper from '~/wrappers/dashboard';
import { t } from '~/i18n';

export default dashboardWrapper(SiteFloorUpdate, t('menu.dashboard.settingsSites'));
